import {
  InspectionReviewRateEnum,
  PROJECT_ACTION_GROUP_STATUS,
  VERDICT_ENUM,
} from '@/common/constants';
import {
  RegionActionStatus,
  RegionStatus,
} from '@/features/monitoring/models/IMonitoring';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { GraduationCupIcon } from '@/common/icons/rating/GraduationCup.tsx';
import { LikeIcon } from '@/common/icons/rating/LikeIcon.tsx';
import { SmileIcon } from '@/common/icons/rating/SmileIcon.tsx';
import { DislikeIcon } from '@/common/icons/rating/DislikeIcon.tsx';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const getRegionEventStatus = (status: RegionStatus | undefined) => {
  switch (status) {
    case VERDICT_ENUM.APPROVED:
      return {
        label: 'approved',
        color: 'text-green-default',
        color_bg: 'bg-green-default/10',
      };
    case VERDICT_ENUM.REJECTED:
      return {
        label: 'rejected',
        color: 'text-red-default',
        color_bg: 'bg-red-default/10',
      };
    case VERDICT_ENUM.PARTIALLY:
      return {
        label: 'partially',
        color: 'text-orange-default',
        color_bg: 'bg-orange-default/10',
      };
    default:
      return {
        label: '',
        color: 'text-gray-graphite',
        color_bg: 'bg-gray-graphite/10',
      };
  }
};

export const getRegionActionStatus = (
  status: RegionActionStatus | undefined,
) => {
  switch (status) {
    case PROJECT_ACTION_GROUP_STATUS.APPROVED:
    case VERDICT_ENUM.APPROVED:
      return {
        label: 'approved',
        color: 'text-green-default',
        color_bg: 'bg-green-default/10',
      };
    case PROJECT_ACTION_GROUP_STATUS.REJECTED:
    case VERDICT_ENUM.REJECTED:
      return {
        label: 'rejected',
        color: 'text-red-default',
        color_bg: 'bg-red-default/10',
      };
    case PROJECT_ACTION_GROUP_STATUS.APPROVED_WITHOUT_CHECK:
      return {
        label: 'approved.without.check',
        color: 'text-green-default',
        color_bg: 'bg-green-default/10',
      };
    case PROJECT_ACTION_GROUP_STATUS.CHECKED:
      return {
        label: 'checked',
        color: 'text-dark-blue',
        color_bg: 'bg-dark-blue/10',
      };
    case PROJECT_ACTION_GROUP_STATUS.REQUESTED:
      return {
        label: 'requested',
        color: 'text-orange-default',
        color_bg: 'bg-orange-default/10',
      };
    case PROJECT_ACTION_GROUP_STATUS.PENDING:
      return {
        label: 'pending',
        color: 'text-yellow-default',
        color_bg: 'bg-yellow-default/10',
      };
    case PROJECT_ACTION_GROUP_STATUS.FINISHED:
      return {
        label: 'finished',
        color: 'text-green-default',
        color_bg: 'bg-green-default/10',
      };
    default:
      return {
        label: '',
        color: 'text-gray-graphite',
        color_bg: 'bg-gray-graphite/10',
      };
  }
};

export const getInspectionRateStatus = (
  rate: string | number | null | undefined,
) => {
  switch (rate) {
    case InspectionReviewRateEnum.EXCELLENT:
      return {
        label: 'rate.EXCELLENT',
        color: 'text-green-default',
        color_bg: 'bg-green-default/10',
        icon: GraduationCupIcon,
      };
    case InspectionReviewRateEnum.GOOD:
      return {
        label: 'rate.GOOD',
        color: 'text-blue-500',
        color_bg: 'bg-blue-500/10',
        icon: LikeIcon,
      };
    case InspectionReviewRateEnum.MEDIUM:
      return {
        label: 'rate.MEDIUM',
        color: 'text-orange-default',
        color_bg: 'bg-orange-default/10',
        icon: SmileIcon,
      };
    case InspectionReviewRateEnum.UNSATISFIED:
      return {
        label: 'rate.UNSATISFIED',
        color: 'text-red-default',
        color_bg: 'bg-red-default/10',
        icon: DislikeIcon,
      };
    default:
      return null;
  }
};

export const clearLocalStorageOnUpdate = () => {
  const CURRENT_VERSION = '1.0.1';
  const storedVersion = localStorage.getItem('appVersion');

  if (storedVersion !== CURRENT_VERSION) {
    localStorage.clear();
    localStorage.setItem('appVersion', CURRENT_VERSION);
  }
};
